<div class="event-wrapper-container" (click)="clickEmitter.next(event)">
  <div *ngIf="colSidePosition===ngxTimelineItemPosition.ON_RIGHT" class="arrow left"
    [ngStyle]="{'border-right': arrowBlock(event?.eventInfo)}"></div>
  <div class="event" [ngClass]="{'enableAnimation': enableAnimation}" [ngStyle]="backGroundColor(event?.eventInfo)">
    <ng-container *ngTemplateOutlet="innerEventCustomTemplate || innerEventContainer; context: {event: event}">
    </ng-container>
  </div>
  <div *ngIf="colSidePosition===ngxTimelineItemPosition.ON_LEFT" class="arrow right"
    [ngStyle]="{'border-left': arrowBlock(event?.eventInfo)}"></div>
</div>

<ng-template #innerEventContainer let-event=event>
  <div class="event-container" [ngClass]="{'reverse': colSidePosition === ngxTimelineItemPosition.ON_LEFT}">
    <div class="event-info-container">
      <div class="event-info-header">
        <div class="title-container">{{event?.eventInfo?.title | titlecase}}</div>
      </div>
      <div class="event-info-body">
        <p class="event-info-description">{{event?.eventInfo?.description}}</p>
      </div>
    </div>

    <div class="event-divider-container">
      <hr />
    </div>

    <div class="event-date-container" *ngIf="getDateObj() as dateObj">
      <div>
        <p>{{dateObj?.month}}</p>
      </div>
      <div>
        <p class="day">{{dateObj?.day}}</p>
      </div>
      <div>
        <p>{{dateObj?.year}}</p>
      </div>
    </div>
  </div>
</ng-template>